import React, {useCallback, useEffect, useRef, useState} from 'react';
import '../Styles/Comment.css'
import RightClickMenu from "./Components/RightClickMenu";

const style = {
    outline: "2px solid orange",
}



const Comment = ({data, id}) => {

    const [active, setActive] = useState(false)
    const [stl, setStl] = useState({})
    const textArea = useRef()
    const [menu, showMenu] = useState(false)
    const onDoubleClick = useCallback((event)=>{
        setActive(true)
        setStl(style)

    },[])

    const DisableActive = useCallback((event)=>{
        setActive(false)
        setStl({})

        showMenu(false)
    },[])

    useEffect(()=>{
        data.ActivFun = DisableActive
        data.active = onDoubleClick
    },[])

    useEffect(()=>{
        if(!active){



            // let q = JSON.stringify(textArea.current.style.width)
            // 

            data.size.width = textArea.current.style.width
            data.size.height = textArea.current.style.height

        }


    },[active])


    return (
<div   className="comment" style={stl}>  { !active &&   <div
    onContextMenu={
        event => {
            event.preventDefault()
            showMenu(!menu)
        }
    }
    onDoubleClick={onDoubleClick} className="Shild"></div>  }
    {menu && <RightClickMenu data={data} id={id}/>  }
<div>

            <textarea ref={textArea}
                onChange={(event)=>data.text = event.target.value}
                      defaultValue={data.text} style={{color:"black", width:data.size.width, height: data.size.height}}
                      className="TextAreaComment"   ></textarea>


</div>
</div>

)

};

export default Comment;